/**
 * L'espace courant (un espace par marque) : lequel montrer, et s'en souvenir d'une visite à
 * l'autre. Le souvenir vit dans le navigateur, par compte ; s'il est illisible (navigation
 * privée, stockage bloqué), on retombe simplement sur le premier espace.
 */
export type WorkspaceRef = { id: string; name: string; role: string };

/** Le même ordre que l'iPhone : l'espace affiché s'il existe encore, sinon celui retenu, sinon le premier. */
export function pickWorkspace(listed: readonly WorkspaceRef[], saved: string | null, current: string | null = null): string | null {
  const ids = new Set(listed.map((w) => w.id));
  if (current && ids.has(current)) return current;
  if (saved && ids.has(saved)) return saved;
  return listed[0]?.id ?? null;
}

const key = (uid: string) => `editit.workspace.${uid}`;

export function savedWorkspace(uid: string): string | null {
  try {
    return localStorage.getItem(key(uid));
  } catch {
    return null;
  }
}

export function rememberWorkspace(uid: string, id: string | null): void {
  try {
    if (id) localStorage.setItem(key(uid), id);
    else localStorage.removeItem(key(uid));
  } catch {
    // Rien à faire : sans stockage, on rouvrira sur le premier espace.
  }
}

/** Le nom tel que le serveur l'enregistrera (1 à 60 caractères), ou null. */
export function cleanWorkspaceName(raw: string): string | null {
  const clean = raw.trim().replace(/\s+/g, " ");
  return clean.length >= 1 && clean.length <= 60 ? clean : null;
}
